import { Nomenclature } from '@feature/nomenclature';
import {
  Author,
  AuthorRequest,
  Currency,
  IdentityRequest,
  PartialAuthor,
  PublishedAt,
  PublishedAtRequest,
} from '@feature/utils';

export const projectStatusList = ['SUBMITTED', 'IN_PROGRESS', 'WON'] as const;

export type ProjectStatus = (typeof projectStatusList)[number];

export interface StatusYear {
  id: number;
  year: number;
  status: ProjectStatus;
}

export interface Financing {
  id: number;
  type: Nomenclature;
  financerName: string;
}

export interface Project {
  id: number;
  title: string;

  //todo: change to date name to createdAt
  creationDate: string;

  contractValue: number;
  currency: Currency;
  statusYear: StatusYear[];
  competitionName: string | null;
  competition: Nomenclature;
  financing: Financing | null;

  competitionType: Nomenclature | null;
  registrationNumber: string | null;
  contractNo: string | null;
  startDate: PublishedAt;
  endDate: PublishedAt;

  percentObtainedOfMinScore?: number | null;

  contribution: Nomenclature | null;

  authors: Author[];
}

export interface StatusYearRequest {
  year: number;
  status: ProjectStatus;
}

export interface FinancingRequest {
  type: IdentityRequest | null;
  financerName: string | null;
}

export interface ProjectRequest {
  title: string;

  contractValue: number;
  currency: Currency;

  statusYear: StatusYearRequest[];
  competitionName?: string | null;
  competition: IdentityRequest;
  competitionType: IdentityRequest | null;
  financing: FinancingRequest | null;

  contribution: IdentityRequest | null;

  registrationNumber: string | null;
  contractNo: string | null;
  startDate: PublishedAtRequest;
  endDate: PublishedAtRequest;

  authors: AuthorRequest[];
}

export interface ProjectSearchRequest {
  title: string;
  contractNo: string;
  registerNo: string;
}

export interface ReclaimRequest {
  projectId: number;
  authorId: number;
}

export interface ReclaimableProject {
  id: number;
  title: string;
  authors: PartialAuthor[];
}

export interface ProjectReclaimSearch {
  project: ReclaimableProject | null;
}
